import { useCallback, useState } from 'react'
import { useLocation, withRouter } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Breadcrumb } from '../../../iba-components/Breadcrumb'
import { showPopBanner } from '../../../iba-components/PopBanner'
import { Tab } from '../../../iba-components/Tab'
import './clientManagementDetail.css'
import { MENU_LIST } from '../../constants'
import UserManagement from './components/UserManagement/userManagement'
import ClientInfoManagement from './components/ClientInfoManagement/clientInfoManagement'
import { SuspendAndTermination } from './components/SuspendAndTermination/suspendAndTermination'
import { getSysClient, updateTerminated } from '../../api/client_managementV2'
import styles from './index.module.css'

const ClientManagementDetail = () => {
    const location = useLocation()
    const { t } = useTranslation()
    const id = location.state.id

    const [companyName, setCompanyName] = useState(location.state.company_name)
    const [clientInfo, setClientInfo] = useState({})
    const [clientInfoLoading, setClientInfoLoading] = useState(false)
    const [suspendAndTerminationLoading, setSuspendAndTerminationLoading] = useState(false)
    const [emrgncyStop, setEmrgncyStop] = useState(false)

    const userInfo = useSelector((state) => state.userInfo)

    // // クライアント情報管理
    const fetchClientInfo = useCallback((callbackFn) => {
        setClientInfoLoading(true)

        getSysClient({
            clientid: `${id}`
        }).then(
            (res) => {
                setClientInfoLoading(false)
                res.clientInfo.clientthememapid = res.clientInfo.clientthememapid
                    ? `${res.clientInfo.clientthememapid}`
                    : ''
                setClientInfo(res.clientInfo)
                setEmrgncyStop(res.emrgncy_stop)
                if (callbackFn) {
                    callbackFn()
                }
            },
            (_err) => {
                setClientInfoLoading(false)
                if (callbackFn) {
                    callbackFn()
                }
            }
        )
    }, [])

    // 解約
    const terminateClient = async () => {
        setClientInfoLoading(true)
        const res = await updateTerminated({
            createby: userInfo.userinfo.username,
            clientid: `${id}`,
            terminated: !clientInfo.terminated
        }).catch(() => {
            setClientInfoLoading(false)
        })
        if (res.hasError) {
            showPopBanner({
                message: t(`signUpClient.warningMsg.registrationError`),
                status: 'error',
                duration: 2000
            })
            setClientInfoLoading(false)
            return
        }
        showPopBanner({
            message: t(`signUpClient.warningMsg.registrationSuccess`),
            status: 'success',
            duration: 2000
        })
        setClientInfoLoading(false)
        fetchClientInfo()
    }

    // 緊急公開停止
    const doSuspend = () => {
        setSuspendAndTerminationLoading(true)
    }

    // サービス再開
    const doRestart = () => {
        setSuspendAndTerminationLoading(true)
    }

    const itemList = [
        {
            link: MENU_LIST.CLIENT_MANAGEMENT.path,
            text: t('clientManagement.title')
        },
        {
            link: '',
            text: companyName
        }
    ]

    const tabList = [
        {
            label: t('clientManagement.userManagementName'),
            value: 'userManagement',
            children: <UserManagement id={id} />
        },
        {
            label: t('clientManagement.clientInfoManagementName'),
            value: 'clientInfoManagement',
            children: (
                <ClientInfoManagement
                    id={id}
                    updateClient={(name) => {
                        setCompanyName(name)
                    }}
                    fetchClientInfo={fetchClientInfo}
                    clientInfo={clientInfo}
                    clientInfoLoading={clientInfoLoading}
                    terminateClient={terminateClient}
                />
            )
        },
        {
            label: t('clientManagement.emergencySuspend'),
            value: 'suspendAndTermination',
            children: (
                <SuspendAndTermination
                    id={id}
                    emrgncyStop={emrgncyStop}
                    doSuspend={doSuspend}
                    doRestart={doRestart}
                    suspendAndTerminationLoading={suspendAndTerminationLoading}
                />
            )
        }
    ]

    return (
        <div className="common-page client-management-detail-container">
            <div className="client-management-banner">
                <div className="breadcrumb-container">
                    <Breadcrumb itemList={itemList} />
                </div>
                <div className="d-flex justify-content-between align-items-end">
                    <div className="sub-title">{t('clientManagement.title')}</div>
                </div>
            </div>

            <Tab className={styles.tab} itemList={tabList} defaultActiveIndex={0} />
        </div>
    )
}

export default withRouter(ClientManagementDetail)
